<script setup lang="ts">
import { MAX_SECTOR_DEPTH } from "~/modules/sector/constants";
import type { Sector } from "~/modules/sector/models/Sector.interface";
import ILxcFolderPlus from "~icons/lxc/folder-plus";
import ILxcTrash2 from "~icons/lxc/trash-2";

const { t } = useI18n();

const props = defineProps<{
  sector: Sector;
  sectorDepth: number;
}>();

const emit = defineEmits(["add", "remove"]);

function addSector(event: Event) {
  event.preventDefault();
  event.stopPropagation();
  emit("add", props.sector.code);
}

function deleteSector(event: Event) {
  event.preventDefault();
  event.stopPropagation();
  emit("remove", props.sector);
}
</script>

<template>
  <div class="flex gap-0">
    <lxc-button
      v-if="sector.statuses?.granted && sectorDepth < MAX_SECTOR_DEPTH"
      html-type="button"
      type="borderless"
      :title="t('sectors.button.newSub')"
      :icon="ILxcFolderPlus"
      class="invisible"
      @click="addSector"
    />
    <lxc-button
      v-if="sector.statuses?.granted"
      html-type="button"
      type="borderless"
      class="invisible"
      :title="t('sectors.button.remove')"
      :icon="ILxcTrash2"
      @click="deleteSector"
    />
  </div>
</template>
